class Ship {
	id = null;
	name = '';
	partner_id = null;
	price = null;
	location = '';
	active = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Ship;
